import React from 'react';

//Componentes material mui
import { Typography } from '@mui/material';

//Estilos
import { ComponenteExtra1440Style } from './ComponenteExtra1440Style';

export default function ComponenteExtra1440({ Logo = '', Texto = '' }) {
    return (
        <div style={{ width: '100%' }}>
            <div style={ComponenteExtra1440Style.DivStyle}>
                {Logo === null ? null : <img src={Logo} alt="BannerIcon" style={ComponenteExtra1440Style.ImgStyle} />}
                <div style={ComponenteExtra1440Style.DivTextStyle}>
                    <Typography variant='body1' style={ComponenteExtra1440Style.DescriptionTextStyle}>
                        {Texto}
                    </Typography>
                </div>
            </div>
        </div>
    );
}